import { render, staticRenderFns } from "./ProjectConfigurationPopup.vue?vue&type=template&id=c8bdb54e&scoped=true"
import script from "./ProjectConfigurationPopup.vue?vue&type=script&lang=js"
export * from "./ProjectConfigurationPopup.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfigurationPopup.vue?vue&type=style&index=0&id=c8bdb54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bdb54e",
  null
  
)

export default component.exports